<div class="collapse-wrapper">
    <div class="title-section" (click)="toggle()">
        <label>{{ title() }} </label>
        <div class="icon-container">
            <span class="d-flex" [ngClass]="isCollapsed() ? 'arrow-down' : 'arrow-up'"><img src="/assets/images/down-arrow.svg" class="down-arrow-icon" /></span>
        </div>
    </div>

    <div class="block" [@collapse]="isCollapsed()">
        <ng-content></ng-content>
    </div>
</div>